import Main from './IncidentsMain'

export default {
  Main,
}
